/* global history */
/* eslint no-restricted-globals: 0 */

import classnames from "classnames";
import React, { Component } from "react";
import Block from "../Block";
import Column from "../Column";
import ContentWrapper from "../ContentWrapper";
import H2 from "../Headers/H2";
import News from "./News";

const propTypes = {};

const defaultProps = {};

const NewsAndEvent = () => {
    const titleClasses = classnames({
        "text-5xl  font-normal  text-concord-dark-green": true
    });



    return (
        <ContentWrapper>
        <Block>
            <Column className="overflow-hidden">
                <div className="js-news-panel">
                    <H2>News</H2>
                    <News />
                </div>
            </Column>
        </Block>
        </ContentWrapper>
    )
}

NewsAndEvent.propTypes = propTypes;
NewsAndEvent.defaultProps = defaultProps;

export default NewsAndEvent;
